/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useState, useEffect, useContext} from 'react'
import { FirebaseContext } from '../../Services/firebase'

import { TextField, Checkbox, FormControlLabel, Divider, Alert, InputLabel, MenuItem, Select, Switch, Button } from '@mui/material';
 
export default function CustomerInfos(props) {

    const data = {
        nbr: props.Infos.nbr,
        gender: props.Infos.gender || "",
        name: props.Infos.name,
        firstname: props.Infos.firstname,
        adresse: props.Infos.adresse,
        code: props.Infos.code,
        ville: props.Infos.ville,
        type: props.Infos.type,
        acces: props.Infos.acces,
        infosAidant: props.Infos.infosAidant,
        numAidant: props.Infos.numAidant,
        num: props.Infos.num,
        repas: props.Infos.repas,
        menage: props.Infos.menage,
        bricolage: props.Infos.bricolage,
        admin: props.Infos.admin,
        courses: props.Infos.courses || false,
        cheque: props.Infos.cheque,
        prelevement: props.Infos.prelevement,
        virement: props.Infos.virement,
        apa: props.Infos.apa || false,
        alarme: props.Infos.alarme || false,
        contrat: props.Infos.contrat || false,
        mandat: props.Infos.mandat || false,
        dateString: props.Infos.dateString,
        firstDate: props.Infos.firstDate || "",
        lastDate: props.Infos.lastDate || "",
        comment: props.Infos.comment,
        actif: props.Infos.actif,
        origin: props.Infos.origin,
        tourNum: props.Infos.tourNum,
    }
    
    useEffect(() => {
        if (data.comment === undefined) {
            data.comment = "";
        }
        if (data.actif === undefined) {
            data.actif = true;
        }
        if (data.origin === undefined) {
            data.origin = 'Internet'
        }
    }, []);

    const [CustomerData, setCustomerData] = useState(data);
    const firebase = useContext(FirebaseContext)

    var newdate = new Date(props.Infos.dateString)
    const [date, setDate] = useState(newdate);
    const [Sure, setSure] = useState(false);

    const handleCheck = e => {
        setCustomerData({...CustomerData, [e.target.id]: e.target.checked})
    }

    const handleChange = e => {
        setCustomerData({...CustomerData, [e.target.id]: e.target.value})
    }

    const handleGender = (event) => {
        setCustomerData({...CustomerData, gender: event.target.value})
    };

    const areYouSure = e => {
        setSure(true)
    }

    const notSure = e => {
        setSure(false)
    }

    const deleteCustomer = () => {
        firebase.delCustomer(props.uid, props.Infos.name)
        .then(() => {
            window.location.reload()
        })
    }

    function updateInfos() {
        setCustomerData({...CustomerData, dateString: date.toLocaleString()})
        if (CustomerData.virement === undefined) { CustomerData.virement = false }
        try {
            console.log(CustomerData)
            firebase.updateCustomer(props.uid, CustomerData)
            .then(
                alert('Les informations ont bien été modifiées'),
                setTimeout(() => {
                    window.location.reload()
                }, 2000)
            )
            .catch(error => {
                alert(error.message)
            })
        }catch(err) {
            alert(err)
        }
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "20px"}}>
                <div style={{ display: "flex", flexDirection: "column"}}>
                    <div style={{ display: "flex", flexDirection: "column", padding: 10, justifyContent: "start", borderRadius: "10px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"}}>
                        <h3>Informations Client</h3>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                            <div style={{ display: "flex", flexDirection: "column", width: "47%", justifyContent: "space-between", minHeight: 350}}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%"}}>
                                    <TextField id="nbr" label="Numéro de client" variant="outlined" value={CustomerData.nbr} onChange={handleChange}/>
                                    <Select
                                        style={{ textAlign: "left"}}
                                        id="gender"
                                        name="gender"
                                        value={CustomerData.gender}
                                        label="Genre"
                                        onChange={handleGender}
                                        variant='outlined'
                                    >
                                        <MenuItem value={'M.'}>M.</MenuItem>
                                        <MenuItem value={'Mme.'}>Mme.</MenuItem>
                                    </Select>
                                </div>
                                <TextField id="firstname" label="Prénom" variant="outlined" value={CustomerData.firstname} onChange={handleChange}/>
                                <TextField id="code" label="Code postale" variant="outlined" value={CustomerData.code} onChange={handleChange}/>
                                <TextField id="num" label="Téléphone" variant="outlined" value={CustomerData.num} onChange={handleChange}/>
                                <TextField id="type" label="Type de logement" variant="outlined" value={CustomerData.type} onChange={handleChange}/>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", width: "47%", justifyContent: "space-between", minHeight: 350}}>
                                <TextField disabled id="name" label="Nom" variant="outlined" value={CustomerData.name} onChange={handleChange}/>
                                <TextField id="adresse" label="Adresse" variant="outlined" value={CustomerData.adresse} onChange={handleChange}/>
                                <TextField id="ville" label="Ville" variant="outlined" value={CustomerData.ville} onChange={handleChange}/>
                                <TextField
                                    id="dateString"
                                    label="Dâte de naissance"
                                    type="date"
                                    value={CustomerData.dateString}
                                    sx={{ width: 210 }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChange}
                                    variant='outlined'
                                />
                                <TextField id="acces" label="Accès" variant="outlined" value={CustomerData.acces} onChange={handleChange}/>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "10px", padding: 10, marginTop: "20px"}}>
                        <h3>Informations Aidant</h3>
                        <TextField id="infosAidant" label="Informations aidant" variant="outlined" value={CustomerData.infosAidant} onChange={handleChange} sx={{marginBottom: "10px"}}/>
                        <TextField id="numAidant" label="Téléphone aidant" variant="outlined" value={CustomerData.numAidant} onChange={handleChange}/>
                    </div>  
                </div>
                <div style={{display: "flex", flexDirection: "column", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "10px", padding: 10}}>
                    <h3>Prestations & paiement</h3>
                    <Divider/>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "20px", marginTop: "20px"}}>
                        <div style={{ display: "flex", flexDirection: "column", marginRight: "50px"}}>
                            <label style={{fontSize: 18, marginBottom: "2vh"}}>Type de prestation:</label>
                            <FormControlLabel control={<Checkbox id="repas" defaultChecked={CustomerData.repas} value={CustomerData.repas} onChange={handleCheck}/>} label="Portage de repas" />
                            <FormControlLabel control={<Checkbox id="menage" defaultChecked={CustomerData.menage} value={CustomerData.menage} onChange={handleCheck} />} label="Ménages" />
                            <FormControlLabel control={<Checkbox id="bricolage" defaultChecked={CustomerData.bricolage} value={CustomerData.bricolage} onChange={handleCheck}/>} label="Bricolage" />
                            <FormControlLabel control={<Checkbox id="admin" defaultChecked={CustomerData.admin} value={CustomerData.admin} onChange={handleCheck} />} label="Aide administrative" />
                            <FormControlLabel control={<Checkbox id="courses" defaultChecked={CustomerData.courses} value={CustomerData.courses} onChange={handleCheck} />} label="Courses" />
                        </div>
                        <Divider/>
                        <div style={{ display: "flex", flexDirection: "column"}}>
                            <label style={{fontSize: 18, marginBottom: "2vh"}}>Type de paiement:</label>
                            <FormControlLabel control={<Checkbox id="cheque" defaultChecked={CustomerData.cheque} value={CustomerData.cheque} onChange={handleCheck} />} label="Chèque" />
                            <FormControlLabel control={<Checkbox id="prelevement" defaultChecked={CustomerData.prelevement} value={CustomerData.prelevement} onChange={handleCheck} />} label="Prélèvement" />
                            <FormControlLabel control={<Checkbox id="virement" defaultChecked={CustomerData.virement} value={CustomerData.virement} onChange={handleCheck} />} label="Virement" />
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column"}}>                    
                    <div style={{ display: "flex", flexDirection: "column", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", borderRadius: "10px", padding: 10}}>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <h3>Autres informations</h3>
                            <div style={{ display: "flex", flexDirection: "row"}}>
                                <div style={{display: "flex", flexDirection: "column", justifyContent: "start"}}>
                                    <TextField
                                        id="firstDate"
                                        label="Dâte de première livraison"
                                        type="date"
                                        value={CustomerData.firstDate}
                                        sx={{ width: 220}}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                        onChange={handleChange}
                                        variant='outlined'
                                    />
                                    <TextField
                                        id="lastDate"
                                        label="Dâte de fin"
                                        type="date"
                                        value={CustomerData.lastDate}
                                        sx={{ width: 220, marginTop: "1vh" }}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                        onChange={handleChange}
                                        variant='outlined'
                                    />
                                    <div style={{ display: "flex", flexDirection: "column"}}>
                                        <InputLabel id="demo-simple-select-label">Origine de la piste</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="origin"
                                            value={CustomerData.origin}
                                            label="Origine de la piste"
                                            onChange={handleChange}
                                            disabled
                                            variant='outlined'
                                        >
                                            <MenuItem value="Internet">Internet</MenuItem>
                                            <MenuItem value="Clients">Clients</MenuItem>
                                            <MenuItem value="Assistante sociale">Assistante sociale</MenuItem>
                                            <MenuItem value="Médicale">Médicale</MenuItem>
                                            <MenuItem value="Bouche à oreille">Bouche à oreille</MenuItem>
                                            <MenuItem value="Autre">Autre</MenuItem>
                                        </Select>
                                    </div>   
                                </div>
                                <div style={{display: "flex", flexDirection: "column", marginLeft: "40px"}}>
                                    <FormControlLabel control={<Checkbox id="apa" defaultChecked={CustomerData.apa} value={CustomerData.apa} onChange={handleCheck} />} label="A.P.A" />
                                    <FormControlLabel control={<Checkbox id="alarme" defaultChecked={CustomerData.alarme} value={CustomerData.alarme} onChange={handleCheck} />} label="Télé-alarme" />
                                    <FormControlLabel control={<Checkbox id="contrat" defaultChecked={CustomerData.contrat} value={CustomerData.contrat} onChange={handleCheck} />} label="Contrat" />
                                    <FormControlLabel control={<Checkbox id="mandat" defaultChecked={CustomerData.mandat} value={CustomerData.mandat} onChange={handleCheck} />} label="Mandat" />
                                </div>
                            </div>
                            <FormControlLabel control={<Switch id='actif' defaultChecked={CustomerData.actif} value={CustomerData.actif} onChange={handleCheck} />} label="actif" />
                            <TextField style={{marginTop: "1vh", marginBottom: "1vh"}}  type="text" id="comment" name="comment" multiline rows={3} value={CustomerData.comment} onChange={handleChange} label="Commentaire (Allergies, Intolérances ...)" variant="outlined"/>
                            <TextField type="text" id="tourNum" name="tourNum" value={CustomerData.tourNum} onChange={handleChange} label="Numéro de tournée" variant="outlined"/>
                            <div style={{display: "flex", flexDirection: "row", marginTop: "3vh"}}>
                                <Button variant="contained" onClick={updateInfos}>Modifier</Button>
                                <Button variant="contained" onClick={areYouSure} style={{marginLeft: "1vw", backgroundColor: "red"}}>Supprimer</Button>
                                {
                                    Sure === true ? 
                                    <Alert severity="warning" style={{marginLeft: "1vw"}}
                                        action={
                                            <>
                                                <Button onClick={deleteCustomer} color="inherit" size="small">
                                                    Confirmer
                                                </Button>
                                                <Button onClick={notSure} color="inherit" size="small">
                                                    Annuler
                                                </Button>
                                            </>
                                        }
                                    >
                                        Êtes-vous sûr de vouloir supprimer cette fiche client ?<br/>Aucune action ne pourra être effectuée pour revenir en arrière après la suppression.
                                    </Alert>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}